import { useMemo } from "react";
import { getEnv } from "../config";
import { GetAvailableLicensesResponse, KamstrupLicenses, useAvailableLicenses } from "../api";

export const useFlowApps = () => {
  const { data: licenses } = useAvailableLicenses();

  const data = useMemo(() => {
    if (licenses) {
      const menuItems = [
        {
          key: "applink-mykamstrup",
          label: "topBar.menu.myKamstrup",
          defaultMessage: "My Kamstrup",
          url: getEnv().REACT_APP_MY_KAMSTRUP
        }
      ];
      if (checkLicense(licenses, KamstrupLicenses.READyPlusDashboardLicense)) {
        menuItems.push(
          {
            key: "applink-dashboard",
            label: "topBar.menu.dashboard",
            defaultMessage: "Dashboard",
            url: `${window.location.origin}${getEnv().PUBLIC_URL}`
          },
          {
            key: "applink-operations",
            label: "topBar.menu.operations",
            defaultMessage: "Operations",
            url: getEnv().REACT_APP_OPERATIONS_URL || ""
          }
        );
      }
      if (checkLicense(licenses, KamstrupLicenses.READyPlusAlarmsLicense)) {
        menuItems.push({
          key: "applink-alerts",
          label: "topBar.menu.alerts",
          defaultMessage: "Alerts",
          url: getEnv().REACT_APP_ALERTS_URL || ""
        });
      }
      if (checkLicense(licenses, KamstrupLicenses.READyPlusCustomerServiceLicense)) {
        menuItems.push({
          key: "applink-customerservice",
          label: "topBar.menu.customerService",
          defaultMessage: "Customer Service",
          url: getEnv().REACT_APP_CUSTOMERSERVICE_URL || ""
        });
      }
      if (checkLicense(licenses, KamstrupLicenses.READyPlusNetworkMonitorLicense)) {
        menuItems.push({
          key: "applink-nem",
          label: "topBar.menu.nem",
          defaultMessage: "Network Monitor",
          url: getEnv().REACT_APP_NEM_URL || ""
        });
      }
      if (checkLicense(licenses, KamstrupLicenses.LeakDetectorLicense)) {
        menuItems.push({
          key: "applink-leakdetector",
          label: "topBar.menu.leakDetector",
          defaultMessage: "Leak Detector",
          url: getEnv().REACT_APP_LEAKDETECTOR_URL || ""
        });
      }
      return menuItems;
    } else return [];
  }, [licenses]);

  return { data };
};

const checkLicense = (
  availableLicenses: GetAvailableLicensesResponse,
  licenseToCheck: KamstrupLicenses
) => availableLicenses?.licensesAvailable.includes(licenseToCheck);
